import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Store } from '@ngrx/store';
import * as fromStore from '../../../store';
import { Observable, Subject, combineLatest } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppConfigService } from '../../../services/app-config.service';
import { isODM, environment, Confirm_button } from '../../../../environments/environment';
import { SelectItem, ToastMessageOptions as Message, TreeNode, MessageService } from 'primeng/api';
import { Table } from 'primeng/table';
import { MspRegion } from '../../../my-features/region/region.model';
import { Account } from '../../../my-features/account/account.model';
import { UpdateInfoModel } from '../../../my-features/updateInfo/update-info.model';
import { authorityMap, updateInfoType, ssoType, containerType, monthMap, urlPath, PROStatus, planChargeInfo, PROType,
         PROTypeIndex, ChargeType, PROStatusIndex, ActionType } from '../../../shareModel';
import { Update } from '@ngrx/entity';
import { Location } from '@angular/common';
import * as fromMyfeatures from '../../../my-features';
import * as fromFeature from '../../../my-features';
import { AzureBlobStorageParam } from 'src/app/my-features/azure-blob-storage/azure-blob-storage.model';
import { DialogComponent } from '../../../../app/dialog/dialog.component';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { RegionService } from '../../../services/region.service';
import { CryptoService} from '../../../services/crypto.service';
import { AccountService } from '../../../services/account.service';

declare var paypal: any;
@Component({
  standalone: false,
  selector: 'app-msp-admin',
  templateUrl: './msp-admin.component.html',
  styleUrls: ['./msp-admin.component.css']
})
export class MspAdminComponent implements OnInit, OnDestroy {
  private paypalContainerRef: ElementRef;
  @ViewChild('rootfile_upload', { static: false }) myRootInputVariable: ElementRef;
  @ViewChild(DialogComponent, { static: false }) childDialog: DialogComponent;
  @ViewChild('paypalContainer', { static: false }) set paypalContainer(element: ElementRef) {
    if (element) { // 只有當元素被渲染到 DOM 中時，element 才會有值
      // console.log('PayPal container is now available in the DOM.');
      this.paypalContainerRef = element;
      // 在這裡呼叫渲染函式，確保按鈕在容器出現後才被渲染
      this.renderPayPalButton();
    }
  }
  @ViewChild('AccountActivitydt', { static: false }) table: Table;
  paypalBtnStyle = {
    shape: 'rect',
    color: 'blue',
    layout: 'horizontal',
    label: 'checkout',
    tagline: false,
  };
  isFormValid: boolean = false;
  
  // 這個屬性將用來儲存 PayPal 按鈕的控制物件
  private paypalActions: any = null;
  private componentDestroyed = new Subject();
  powerMaster = isODM;
  Confirm_button = Confirm_button;
  isMsp = false;
  IsSuperAdmin = false;
  IsSalesAdmin = false;
  IsRegionAdmin = false;
  IsInternalAdmin = true;
  otp: string;
  CurrentUser: string;
  authority: any;
  region: MspRegion[];
  treeRegion: any[] ;
  /** 來自 getMspRegion（與一般 Region 列表欄位不完全相同） */
  allRegion: MspRegion[];
  account: any[];
  accountDic = {};
  regionId: number;
  mspRegionId: number;
  selectedFile: any;
  IsSelectedCompanyHierarchyMsp = false;
  IsLocalAdminMsp = false;
  selectedNode: any;
  selectedRegion: any;
  hierarchyDataTree: any;
  regionTable_cols = [];
  customer_cols: any[] = [];
  ReadRegionParam = {
    MspMainRegionId: 0,
    otp: ''
  };
  companyPlanConfirm: {
    Id: number;
    IsMsp?: boolean;
    MspDeviceLimit: number;
    // MspPlanLevel: number;
    MspPlanTime: number;
    MspActivate?: boolean;
    MspPlanMgtId?: number;
    MspPlanName?: string;
  };
  generateCompanyPlanConfirmDialog = false;
  // 2025-07-31 kyrie 手動Activate MSP功能移除
  // activateCompanyPlanConfirmDialog = false;
  deleteRegionDialog = false;
  adminSettingsDialog = false;
  confirmSaveAdminDialog = false;
  dialogInput: {
    name: string;
    RegionName: string;
    Domain: string;
    UpdateType: string;
    Note: string;
    Id: number;
    Admins?: number[];
    MSPAdmin: number;
    EnableDomain?: boolean;
    SSOEnable: boolean;
    SAMLCert?: string;
    SAMLCertFile?: string;
    Identifier: string;
    ReplyUrl: string;
    LoginUrl: string;
    MspDomain: string;
    SSOEntityId: string;
  };
  selectDefaultTab: string;
  adminsOptions: SelectItem[];
  MSPAdminOptions: SelectItem[];
  /** Edit Company 時先暫存已選 Admins，等 options 載入再寫回，避免 MultiSelect 短暫顯示 null */
  private pendingEditAdmins: number[] = null;
  planTypeOptions: SelectItem[] = [];
  planTimeOptions: SelectItem[] = [
    { label: '1 Year', value: 365 },
    { label: '2 Year', value: 730 },
    { label: '3 Year', value: 1095 },
  ];
  actionTypeOptions: SelectItem[] = [
    { label: 'Any Type', value: 0 },
    { label: 'Monthly Usage', value: 1 },
    { label: 'Sell', value: 2 },
    { label: 'Purchase', value: 11 },
  ];
  UpdateInfoParam = {} as UpdateInfoModel;
  regionName = '';
  parentRegionId: number;
  NonParentRegion = [];
  AddHierarchyParams = {
    companySource: 0,
    childCompany: 0,
  };
  licenseMgtList = [];
  url: any;
  SAMLCertFileToUpload: File = null;
  displayHierarchyConfirmDialog = false;
  hierarchyDialog = false;
  editHierarchyStatus = false;
  hierarchydialogInput: {
    UpdateType: string;
  };
  globalSelectedRegionName: string;
  globalSelectedRegionId: number;
  globalSelectedParentRegionId: number;
  globalIsClickMemberbutton = false;
  CompanyOptions$: Observable<any>;
  CompanyOptions = [];
  ssoFileContainer?: string;

  disableMainMSPAdminDropdown = false;
  // showMainMSPAdminDropdownList = false;
  mainMspAdmin: string;
  inheritDialog = false;
  planMgtDic = {};
  totalDeviceUsage = 0;
  datePickStart: Date;
  getMspDeviceUsageParam = {
    otp: '',
    RegionId: 0,
    IsDistributorAll: false
  };
  getMspRegionParam = {
    otp: '',
    RegionId: []
  };
  getPaymentByDistributorParam = {
    RegionId: 0,
    otp: ''
  };
  getMspAuthorityParam = {
    otp: '',
    RegionIds: []
  };
  getProNodesParam = {
    otp: '',
    RegionIds: []
  };
  hashMspUsageRegionId: string;
  filter_deviceUsage_flag = false;
  customer: any[];
  PROType: number = -1;
  ChargeType = ChargeType;
  PROTypeIndex = PROTypeIndex;
  paymentUnitPrice: number;
  payment_dic: any[];
  selectedRegionName: string = '';
  adminMembers: any[];
  CustomerManagerOptions: any[];
  regionLoaded = false;
  acode: number;
  accountActivityListAll = [];
  accountActivityList = [];
  accountActivityNodeBank: number = 0;
  accountActivityNodeBank_Dic = [];
  accountActivityTable_cols: any[] = [
    { field: 'CreateTime', header: "Time", width: '180', class: 'col-nowrap' },
    { field: 'RegionId', header: 'Company', width: '220', class: 'col-nowrap' },
    { field: 'ActionTypeStr', header: 'Type', width: '180', class: 'col-nowrap' },
    { field: 'DisplayNodes', header: 'Quantity (NPM)', width: '180', class: 'col-nowrap' },
    { field: 'Balance', header: 'NPM Bank Balance', width: '180', class: 'col-nowrap' },
  ];
  PROPaymentSetting = {
    CurrentNPMBank: 0,
    DocDay: 0,
    UserChargeType: null,
    PaymentRegionId: 0,
    PaymentNPMBank: 0,
    TotalAmount: 0,
    AfterPayment: 0,
  };
  predictedNPMUsageList = [];
  predictedNPMUsage = {
    LastDeviceUsage: 0,
    Growth: 0,
    PredictedDeviceUsage: 0,
    SettlementDate: '2025/02/01',
    PredictedBank: 0,
  }
  predictedNPMUsageTable_cols: any[] = [
    { field: 'LastDeviceUsage', header: 'NPM Usage Last Month', width: '180', class: 'col-nowrap' },
    { field: 'Growth', header: 'NPM Usage growth this month', width: '250', class: 'col-nowrap' },
    { field: 'PredictedDeviceUsage', header: 'Predicted NPM Usage This Month', width: '300', class: 'col-nowrap' },
    { field: 'SettlementDate', header: 'Next Settlement Date', width: '200', class: 'col-nowrap' },
    { field: 'PredictedBank', header: 'Predicted NPM Bank This Month', width: '250', class: 'col-nowrap' },
  ];
  regionOptions: SelectItem[];
  monthOptions: SelectItem[] = [];
  yearOptions: SelectItem[] = [];
  selectedCompany: number = 0;
  selectedYear: Number = 0;
  selectedMonth: Number;
  selectedActionType = 0;
  dialogVisibility = {
    transfer: false,
    addCustomer: false,
    editCustomer: false,
    deleteWarningCustomer: false,
    deleteCustomer: false,
    PayByCard: false,
    PayByCardResult: false,
  };
  transferDialogInput: {
    quantity: number;
    source: number;
    target: number;
    sourceNpm: number;
    targetNpm: number;
  };
  disabledTransferConfirmButton: boolean = false;
  CompanySourceOptions = [];
  CompanyTargetOptions = [];
  mainChildRegionNpm: number;
  addCustomerStepIndex: number = 1;
  addCustomerDialogInput: {
    UpdateType: string;
    name: string;
    status: number;
    account: string;
    type: string;
    quantity: number;
    ownerAccount: string;
  };
  transferAccountError: boolean = false;
  transferAccountErrorMessage: string = '';
  selectedCustomer: any;
  deleteWarningCustomerStepIndex: number = 1;
  deleteCustomerStepIndex: number = 1;
  deleteCustomerDialogInput: {
    Id: number;
    name: string;
    TargetAccount: string;
  };
  PayByCardDialogInput: {
    defaultTab: string;
    type: string;
    quantity: number;
    paypalStatus: number;
  };
  PayByCardResult: number = 1;
  CurrentNodesBank: number;
  default100NPlanMgtId: number;
  checkTransferAccountFail = false;
  checkTransferAccountResult: any;
  PROStatusIndex = PROStatusIndex;
  ActionType = ActionType;
  display_paypal_btn = false;
  deviceUsage_list_dic = [];
  payment_regionId_dic = [];
  region_docDay_dic = [];
  IsProMainRegionAdmin = false;
  unActiveCompanyNPM = 0;
  constructor(private ngxService: NgxUiLoaderService, private store: Store<fromStore.State>, private router: Router,
    private appConfigService: AppConfigService, private location: Location, private messageService: MessageService,
    private cryptoService: CryptoService,
    private route: ActivatedRoute) {
    this.getDefaultDate();

    const hashId = this.cryptoService.aesDecrypt(this.route.snapshot.paramMap.get('id'));
    if (hashId) {
      this.ReadRegionParam = {
        MspMainRegionId: parseInt(hashId),
        otp: ''
      };
      this.mspRegionId = parseInt(hashId);

      // this.store.select(fromStore.GetProNodesBank).pipe(takeUntil(this.componentDestroyed)).subscribe((res) => {
      //   if (res.isLoaded && !res.isLoading) {
      //     this.accountActivityListAll = res.entities;
      //     this.accountActivityList = res.entities;
          
      //     this.getPredictedNPMUsageData();
      //     this.getPredictedNPMUsage();
      //     this.generateYearOptions();
      //   }
      // });
    } else {
      // For Pro CompanyManageMent Get MspMainRegionId
      this.store.select(fromStore.getCurrentUser).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
        if (!this.regionLoaded && res !== undefined) {
          // Get IsMsp
          this.isMsp = res.isMsp;
          this.acode = res.acode;
          this.CurrentUser = res.currentUser;
          // Msp Region
          this.IsSuperAdmin = res.authority === 2;
          if (res.isMsp) {
            this.selectedCompany = res.RegionId;
            this.patchReadRegionParam({ MspMainRegionId: res.RegionId });
          }
        }
      });

      this.store.select(fromStore.getRegions).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
        if (!this.regionLoaded && res !== undefined && res.length > 0) {
          if (
            this.isMsp && this.IsSuperAdmin === false) {
            const mspMainRegionItem = res.find(r => r.Admins !== undefined && r.Admins.filter(i => i === this.acode) !== undefined);            
            const mspMainRegionId = mspMainRegionItem !== undefined ? mspMainRegionItem.MspMainRegionId : undefined;
            const params = {
              RegionId: [mspMainRegionId],
              otp: ''
            };
            this.dispatchGetMspRegions();
            if (!this.isMsp || (this.isMsp &&  this.ReadRegionParam.MspMainRegionId == mspMainRegionId)) { // 若為Pro則需要為母公司
              this.store.dispatch(new fromFeature.GetMspRegionPayment(params));
            }
            this.regionLoaded = true;
            this.parentRegionId = mspMainRegionItem.ParentRegionId;
          }
        }
      });
    }

    this.store.select(fromStore.GetProNodesBank).pipe(takeUntil(this.componentDestroyed)).subscribe((res) => {
      if (res.isLoaded && !res.isLoading) {        
        this.accountActivityListAll = Array.isArray(res.entities) ? res.entities.map((e) => ({ ...e })) : [];
        this.accountActivityList = Array.isArray(res.entities) ? res.entities.map((e) => ({ ...e })) : [];
        
        this.getPredictedNPMUsageData();
        this.getPredictedNPMUsage(this.mspRegionId);
        this.generateYearOptions();
        this.AccountAcitvityFilter();
      }
    });

    // Msp Data
    combineLatest(this.store.select(fromStore.getIsMsp), this.store.select(fromStore.getCurrentUser), this.store.select(fromStore.getRegions))
    .pipe(takeUntil(this.componentDestroyed))
    .subscribe(([getIsMspRes, getCurrentUserRes, region]) => {
      if ((getIsMspRes !== undefined && getIsMspRes !== null) && (getCurrentUserRes !== undefined && getCurrentUserRes !== null) && 
      (region !== undefined && region !== null && region.length > 0)) {
        if (this.isMsp && this.IsSuperAdmin === false) {
          const mspMainRegionItem = region.find(r => r.Admins !== undefined && r.Admins.filter(i => i === this.acode) !== undefined);
          const mspMainRegionId = mspMainRegionItem !== undefined ? mspMainRegionItem.MspMainRegionId : undefined;
          this.ReadRegionParam = {
            MspMainRegionId: mspMainRegionId,
            otp: ''
          };
          this.dispatchGetMspRegions();
          this.regionLoaded = true;
        }
        // Get IsMsp
        // this.isMsp = getIsMspRes;

        // Msp Region
        this.IsSuperAdmin = getCurrentUserRes.authority === 2;
        this.authority = getCurrentUserRes.authority;
        this.regionId = getCurrentUserRes.RegionId;
        this.otp = getCurrentUserRes.otp;
        // Get Sales Admin Authority List（加入防呆避免 appConfig 或 sales 為 undefined 時出錯）
        const appConfig = this.appConfigService.getConfig();
        this.IsSalesAdmin = !!(appConfig && Array.isArray(appConfig.sales) &&
          appConfig.sales.some((acode) => acode === getCurrentUserRes.acode));
        this.IsRegionAdmin = !this.isMsp && (getCurrentUserRes.authority === 1);
        this.IsInternalAdmin = this.isMsp && (this.regionId != this.ReadRegionParam.MspMainRegionId);
        this.regionTable_cols = [];
        this.customer_cols = [];
        this.regionTable_cols = [
          // { field: '', header: 'No.', width: '50', class: 'col-nowrap sortIcon-false', sortIcon: false, visible: true, },
          { field: 'RegionName', header: 'Company Name', width: '250', class: 'col-nowrap', sortIcon: true, visible: true, },
          // { field: 'Region', header: 'Domain', width: '180', class: 'col-nowrap', sortIcon: true, visible: true, },
          { field: 'account', header: 'Account Manager', width: '240', class: '', sortIcon: true, visible: true, },
          { field: 'adminMembers', header: 'Device Manager', width: '240', class: '', sortIcon: true, visible: true, },
          { field: 'members', header: 'Viewer', width: '240', class: '', sortIcon: true, visible: true, },
          { field: 'MspPlanLevel', header: 'License Level', width: '170', class: 'col-nowrap', sortIcon: true, visible: (!this.powerMaster && this.IsSuperAdmin) , },
          { field: 'DeviceUsage', header: 'Used Device', width: '170', class: 'col-nowrap', sortIcon: true, visible: !this.powerMaster, },
          { field: '', header: '', width: '90', class: 'col-nowrap default', sortIcon: false, visible: !this.powerMaster, },
        ];
        if (!this.IsSuperAdmin) {
          this.regionTable_cols = this.regionTable_cols.filter(s=> s.field !== '');
        }
        this.customer_cols = [
          { field: '', header: 'No.', width: '50', class: 'col-nowrap sortIcon-false', sortIcon: false, visible: true, },
          { field: 'RegionName', header: 'Company', width: '180', class: 'col-nowrap', sortIcon: true, visible: true, },
          { field: 'Account', header: 'Account Manager', width: '240', class: '', sortIcon: true, visible: true, },
          { field: 'UsedDevice', header: 'NPM Usage', width: '180', class: 'col-nowrap', sortIcon: true, visible: !this.powerMaster, },
          { field: 'NpmBank', header: 'NPM Bank', width: '180', class: 'col-nowrap', sortIcon: true, visible: !this.powerMaster, },
          { field: 'CreateTime', header: 'Add Time', width: '240', class: 'col-nowrap', sortIcon: true, visible: !this.powerMaster, },
          { field: 'PROStatus', header: 'Status', width: '150', class: 'col-nowrap', sortIcon: true, visible: !this.powerMaster, },
          { field: 'Send', header: '', width: '60', class: 'send', sortIcon: false, visible: !this.powerMaster, }
        ];
        let regionId = getCurrentUserRes.RegionId;
        let mspRegionParam = { ...this.getMspRegionParam, RegionId: [regionId] };
        if (this.IsSuperAdmin || this.IsRegionAdmin) {
          regionId = this.ReadRegionParam.MspMainRegionId;
          if (this.IsSuperAdmin) {
            mspRegionParam = { ...mspRegionParam, RegionId: [] };
          }
        }
        this.getMspRegionParam = mspRegionParam;
        this.getMspDeviceUsageParam = { ...this.getMspDeviceUsageParam, RegionId: regionId };

        if (!this.filter_deviceUsage_flag) {
          this.filter_deviceUsage_flag = true;
          this.getPaymentByDistributorParam = {
            RegionId: regionId,
            otp: ''
          };
          this.getMspDeviceUsageParam = {
            ...this.getMspDeviceUsageParam,
            IsDistributorAll: true,
          };
          this.store.dispatch(new fromFeature.ReadMspDeviceUsageList({ ...this.getMspDeviceUsageParam }));
          if (!this.isMsp || (this.isMsp &&  this.ReadRegionParam.MspMainRegionId == regionId)) { // 若為Pro則需要為母公司
            this.store.dispatch(new fromFeature.GetMspPaymentSettingByDistributor({ ...this.getPaymentByDistributorParam }));
            this.store.dispatch(new fromFeature.GetMspRegionPayment({ ...this.getMspRegionParam }));
          }
        }
      }
    });


    // Get Account Info
    this.store.select(fromStore.getAccountInfo).pipe(takeUntil(this.componentDestroyed)).subscribe((res) => {
      const accountdata = Object.values(res);
      this.account = accountdata;
      accountdata.forEach((a) => {
        this.accountDic[a.Account] = a;
      });
    });

    // Get All Region
    this.store.select(fromStore.getMspRegion).pipe(takeUntil(this.componentDestroyed)).subscribe((res) => {
      if (res !== undefined && res.length > 0) {
        this.PROType = res[0].PROType;
        this.IsProMainRegionAdmin = res[0].MspMainRegionId == res[0].Id ? true : false
        this.allRegion = res;
        this.getMspAuthorityParam = {
          RegionIds: res.map(item => Number(item.Id)),
          otp: ''
        };
        this.store.dispatch(new fromFeature.GetMspAuthority({ ...this.getMspAuthorityParam }));
        this.AccountAcitvityFilter();
      }
    });

    // 從API拉出License Level
    const getPlanMgtParam = {syncAccountsInfo: false};
    this.store.dispatch(new fromFeature.GetPlanMgts(getPlanMgtParam));
    this.store.select(fromStore.getPlanMgtInfo).subscribe(res => {
      if (res.Loaded && !res.Loading) {
        if (res.entities.length > 0) {
          this.planTypeOptions = [...res.entities].sort(function (a: any, b: any) {
            return a.Level - b.Level;
          }).map((item) => {
            if (item.PlanName === planChargeInfo['level_100N'].name) {
              this.default100NPlanMgtId = item.Id;
            }
            this.planMgtDic[item.Id] = item.PlanName;
            return { label: item.PlanName, value: item.Id};
          });
        }
      }
    });

    // Get License Mgt Info
    this.store.select(fromStore.getLicenseState).pipe(takeUntil(this.componentDestroyed)).subscribe((res) => {
      if (res.Loaded && !res.Loading) {
        this.licenseMgtList = Object.keys(res.entities);
      }
    });

    // Get Region Option
    this.CompanyOptions$ = this.store.select(fromStore.getRegionsOptions);
    this.CompanyOptions$.subscribe(options => {
      this.CompanySourceOptions = options;
    });
    this.store.select(fromStore.getMspDistributorRegionPaymentOption(this.ReadRegionParam.MspMainRegionId)).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      this.CompanyOptions = res;
      if (res.length > 0) {
        this.selectedCompany = res[0].value;
      }
    });
    this.store.select(fromStore.GetAzureBlobStoragesDownload).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      // 安全檢查：確保 res 存在後再訪問其屬性
      if (res && !res.isLoading && res.isLoaded && res.blob && res.action === 'download') {
        this.saveFile(res.blob);
      }
    });

    // open member button
    this.store.select(fromStore.getRegionMember).pipe(takeUntil(this.componentDestroyed)).subscribe((res) => {
      if (res.isLoaded && !res.isLoading) {
        if (res.entities) {
          if (res.entities.msg) {
            if (res.entities.msg.body) {
              if (Array.isArray(res.entities.msg.body)) {
                if (this.childDialog !== undefined && this.childDialog.companyMemberList !== undefined) {
                  this.childDialog.companyMemberList = [];
                  // 將子公司自動新增的region在memberlist濾掉
                  this.mainMspAdmin = '';
                  let admin =  [];
                  if (this.selectedRegion.data.Admins !== undefined) {
                    admin = this.selectedRegion.data.Admins.filter(i => i !== this.selectedRegion.data.CreateId);
                  }
                  const mainMspAdminItem = this.account.find(s => s.Acode === this.selectedRegion.data.MainAdmin);
                  res.entities.msg.body.forEach((item) => {
                    if (this.accountDic[item] != undefined) {
                      this.childDialog.companyMemberList.push({ 'account': item, value: item, 'acode': this.accountDic[item].Acode, 'admins': admin, 'company': this.selectedRegion.data.RegionName });
                    }
                  });
                  const members = [];
                  const admins = [];
                  this.childDialog.companyMemberList.forEach(c => {
                    members.push(c.account);
                  });
                  this.account.filter((item) => (item.CompanyId === this.selectedRegion.data.Id && item.Acode !== this.selectedRegion.data.MainAdmin) ||
                  (this.selectedRegion.data.CreateId !== undefined && item.Acode === this.selectedRegion.data.CreateId)).map((item) => {
                    if (members.includes(item.Account)) {
                      admins.push({ label: item.Account, value: item.Acode }) ;
                    } else if (this.selectedRegion.data.Id !== this.selectedRegion.data.MspMainRegionId && this.selectedRegion.data.CreateId !== undefined && item.Acode === this.selectedRegion.data.CreateId) {
                      admins.push({ label: item.Account, value: item.Acode, disabled: true}) ;
                    }
                  });
                  this.adminsOptions = admins;
                  this.MSPAdminOptions = admins;
                  this.applyPendingEditAdmins();

                  if (mainMspAdminItem !== null && mainMspAdminItem !== undefined) {
                    const memberList = this.childDialog.companyMemberList;
                    this.mainMspAdmin = mainMspAdminItem.Account;

                    this.childDialog.companyMemberList = [];
                    memberList.map(s => {
                      if (mainMspAdminItem.Account !== s.account && this.accountDic[s.account] != undefined) {
                        this.childDialog.companyMemberList.push({ 'account': s.account, value: s.account, 'acode': this.accountDic[s.account].Acode, 'admins': admin, 'company': this.selectedRegion.data.RegionName });
                      }
                    });
                  } else {
                    this.childDialog.companyMemberList = [];
                  }
                }
              } else {
                const admins = [];
                this.account.filter((item) => (item.CompanyId === this.selectedRegion.data.Id && item.Acode !== this.selectedRegion.data.MainAdmin) ||
                  (this.selectedRegion.data.CreateId !== undefined && item.Acode === this.selectedRegion.data.CreateId)).map((item) => {
                    admins.push({ label: item.Account, value: item.Acode, disabled: true}) ;
                  });
                this.adminsOptions = admins;
                this.applyPendingEditAdmins();
              }
            }
          }
        }
      }
      if (this.globalIsClickMemberbutton) {
        // tslint:disable-next-line: max-line-length
        this.childDialog.addCompanyMemberDialog(this.globalSelectedRegionName, this.globalSelectedRegionId, this.globalSelectedParentRegionId);
        this.globalIsClickMemberbutton = false;
      }
    });

    this.store.select(fromStore.getUpdateInfoState).pipe(takeUntil(this.componentDestroyed)).subscribe((res) => {
      if (
        res.type === updateInfoType.AddMspCompany ||
        res.type === updateInfoType.UpdateMspCompany ||
        res.type === updateInfoType.ReadMspCompany ||
        res.type === updateInfoType.ActivateRegionMember ||
        res.type === updateInfoType.UpdateRegionMember ||
        res.type === updateInfoType.CheckRegionMember ||
        res.type === updateInfoType.TransferProNodes
      ) {
        if (!res.isLoading && res.isLoaded && res.isSaved) {
          if (res.type !== updateInfoType.ReadMspCompany) {
            if (res.type === updateInfoType.CheckRegionMember) {
              if (this.isMsp) {
                if (res.msg.RespType == '0') {
                  this.checkTransferAccountFail = false;
                  this.checkTransferAccountResult = 0;
                  this.addCustomerStepIndex = 2;
                } else {
                  this.checkTransferAccountFail = true;
                  this.checkTransferAccountResult = res.msg.RespType;
                }
              } else {
                if (this.dialogVisibility.addCustomer) {
                  this.errorCompanyMember(res.msg);
                } else {
                  if (this.globalSelectedRegionId !== undefined) {
                    const regionItem = this.allRegion.find(s => s.Id === this.globalSelectedRegionId);
                    this.childDialog.CompanyName = regionItem !== undefined ? regionItem.RegionName : '';
                  }
                  this.childDialog.errorCompanyMember(res.msg);
                }
              }
            } else if (res.type === updateInfoType.TransferProNodes) {
              this.messageService.add({
                severity: 'success',
                summary: 'Transfer Success',
              });
              this.store.dispatch(new fromFeature.GetMspRegionPayment({ ...this.getMspRegionParam }));
              this.store.dispatch(new fromFeature.GetMspPaymentSettingByDistributor({ ...this.getPaymentByDistributorParam }));
              this.store.dispatch(new fromFeature.GetProNodesBank({ ...this.getProNodesParam }));
              this.clearMessageService();
              this.ngxService.stop();
            } else {
              if (res.type === updateInfoType.AddMspCompany) {
                this.childDialog.addToHierarchyWarning(); // company
              }
              this.getMspRegion();
              this.messageService.add({
                severity: 'success',
                summary: 'Success',
              });
              this.clearMessageService();
            }
          }
        } else if (!res.isLoading && res.isLoaded && !res.isSaved) {
          if (res.type === updateInfoType.UpdateMspCompany) {
            // TODO 更完善的 message 處理尚未完成
            const errMsg = 'Update Msp Company Fail';
            this.messageService.add({
              severity: 'error',
              summary: errMsg,
            });
            this.clearMessageService();
          } else if (res.type === updateInfoType.AddMspCompany) {
            // TODO 更完善的 message 處理尚未完成
            const errMsg = 'Add Msp Company Fail';
            this.messageService.add({
              severity: 'error',
              summary: errMsg,
            });
            this.clearMessageService();
          } else if (res.type === updateInfoType.ReadMspCompany) {
          } else {
            this.messageService.add({
              severity: 'error',
              summary: 'Update Fail',
            });
            this.clearMessageService();
          }
        }
        this.resetUpdateInfoState();
        this.ngxService.stop();
      } else if (res.type === updateInfoType.AddProPaymentPay) {
        this.ngxService.stop();
        if (!res.isLoading && res.isLoaded && res.isSaved) {
          this.store.dispatch(new fromFeature.GetMspRegionPayment({ ...this.getMspRegionParam }));
          this.store.dispatch(new fromFeature.GetProNodesBank({ ...this.getProNodesParam }));
          this.PayByCardResult = 0;
          this.dialogVisibility.PayByCard = false;
          this.dialogVisibility.PayByCardResult = true;
        } else if (!res.isLoading && res.isLoaded && !res.isSaved) {
          this.PayByCardResult = 1;
          this.dialogVisibility.PayByCard = false;
          this.dialogVisibility.PayByCardResult = true;
        }
      } else if (res.type === updateInfoType.ActivateProUpgrade) {
        this.ngxService.stop();
        if (!res.isLoading && res.isLoaded && res.isSaved) {
          this.store.dispatch(new fromFeature.GetMspRegionPayment({ ...this.getMspRegionParam }));
          this.PayByCardDialogInput.type = '1';
          this.dialogVisibility.PayByCard = true;
          this.messageService.add({ severity: 'success', summary: 'Setting Success' });
        } else if (!res.isLoading && res.isLoaded && !res.isSaved) {
          this.messageService.add({ severity: 'error', summary: 'Setting Fail' });
        }
        this.clearMessageService();
      } else if (res.type === updateInfoType.TransferProNodes) {
        if (!res.isLoading && res.isLoaded) {
          this.messageService.add({
            severity: 'error',
            summary: 'Transfer Fail',
          });
          this.clearMessageService();
          this.ngxService.stop();
        }
      } else if (res.type === updateInfoType.AddRegion || res.type === updateInfoType.EditRegion ||
        res.type === updateInfoType.DeleteRegion) {
        if (!res.isLoading && res.isLoaded && res.isSaved) {
          if (this.dialogVisibility.addCustomer) {
            this.addCustomerStep(3);
          }
          if (this.dialogVisibility.editCustomer) {
            this.dialogVisibility.editCustomer = false;
          }
          this.store.dispatch(new fromFeature.GetMspPaymentSettingByDistributor({ ...this.getPaymentByDistributorParam }));
          this.messageService.add({
            severity: 'success',
            summary: 'Update Success',
          });
          this.clearMessageService();
        } else if (!res.isLoading && res.isLoaded && !res.isSaved) {
          if (this.dialogVisibility.addCustomer) {
            // TODO 更完善的 message 處理尚未完成
            const errMsg = 'Add Customer Fail';
            this.messageService.add({
              severity: 'error',
              summary: errMsg,
            });
          }
          if (this.dialogVisibility.editCustomer) {
            const errMsg = 'Update Customer Fail';
            this.messageService.add({
              severity: 'error',
              summary: errMsg,
            });
          }
          if (res.type === updateInfoType.DeleteRegion) {
            const errMsg = 'Delete Customer Fail';
            this.messageService.add({
              severity: 'error',
              summary: errMsg,
            });
          }
          this.clearMessageService();
        }
      } else if (res.type === updateInfoType.SendProUpgradeMail) {
        if (!res.isLoading && res.isLoaded) {
          this.ngxService.stop();
          if (res.isSaved) {
            this.messageService.add({
              severity: 'success',
              summary: 'Send Email Success',
            });
            this.store.dispatch(new fromFeature.GetMspPaymentSettingByDistributor({ ...this.getPaymentByDistributorParam }));
          } else {
            this.messageService.add({
              severity: 'error',
              summary: 'Send Email Fail',
            });
          }
          this.clearMessageService();
        }
      }
    });

    combineLatest(this.store.select(fromStore.getMspRegionAuth),
    this.store.select(fromStore.getMspDeviceUsageList(this.mspRegionId)),
    this.store.select(fromStore.getMspDistributorRegionPayment),
    this.store.select(fromStore.getMspRegionHierarchy))
    .pipe(takeUntil(this.componentDestroyed))
    .subscribe(([mspRegion, mspDeviceUsage_list, distributorData, regionHierarchy]) => {      
      if (mspRegion !== undefined && mspDeviceUsage_list !== undefined) {
        this.region = mspRegion;
        if (this.account !== undefined && this.account.length > 0) {
          mspRegion.map(m => {
            if (m.CreateId !== undefined && m.Account !== undefined) {
              // 排除重複或被加過的
              if (this.account.find(a => a.Acode === m.CreateId) === undefined) {
                this.account.push(
                  {
                    Account: m.Account.account,
                    Acode : m.Account.acode,
                    ConmpanyId: m.Id
                  }
                );
              }
            }
          });
        }
        this.account = [...this.account].sort(function (a: any, b: any) {
          return a.Acode - b.Acode;
        });
        let deviceusage_amount = 0;
        this.deviceUsage_list_dic = [];
        if (Object.keys(mspDeviceUsage_list.deviceUsage).length !== 0) {
          mspDeviceUsage_list.deviceUsage.map((m) => {
            if (m.data !== undefined && m.data.regionid !== undefined) {
              this.deviceUsage_list_dic[m.data.regionid] = m;
            } else {
              if (m.type === 0) {
                
                this.predictedNPMUsage.PredictedDeviceUsage = m.quantity;
                // this.predictedNPMUsage.LastDeviceUsage = m.last_quantity;
                if (m.minCharge !== undefined && m.minCharge !== 0) {
                  if (m.quantity < m.minCharge) {
                    this.predictedNPMUsage.PredictedDeviceUsage = m.minCharge;
                  }
                  // if (m.last_quantity < m.minCharge) {
                  //   this.predictedNPMUsage.LastDeviceUsage = m.last_quantity;
                  // }
                }
                this.predictedNPMUsage.Growth = this.predictedNPMUsage.PredictedDeviceUsage - this.predictedNPMUsage.LastDeviceUsage;
                this.getPredictedNPMUsage(this.mspRegionId);
              }
            }
          });
        }
        const regionIds = [];
        this.region = this.region.map(i => {
          const obj = {
            id: '',
            isDistributor: false
          };
          if (this.ReadRegionParam.MspMainRegionId === i.Id) {
            obj.id = this.ReadRegionParam.MspMainRegionId.toString();
          } else {
            obj.id = this.ReadRegionParam.MspMainRegionId.toString() + ',' + i.Id.toString();
          }
          const hashObj = this.cryptoService.aesEncrypt(obj);
          regionIds.push(i.Id);
          // i.HashId = this.cryptoService.aesEncrypt(i.Id)
          const deviceUsage = mspDeviceUsage_list.deviceUsage_dic[i.Id] != undefined ? mspDeviceUsage_list.deviceUsage_dic[i.Id].DeviceUsage : 0;
          deviceusage_amount = (deviceusage_amount + deviceUsage);
          return {
            ...i,
            DeviceUsage: deviceUsage,
            HashObj: hashObj,
            MspPlanName: this.planMgtDic[i.MspPlanMgtId],
            NpmBank: this.accountActivityNodeBank,
          };
        });
        const mainChildRegion = this.region.find((r) => (r.ParentRegionId === r.MspMainRegionId) || !regionIds.includes(r.ParentRegionId));
        this.mainChildRegionNpm = mainChildRegion.NpmBank;
        this.getTreeRegion();
        this.hashMspUsageRegionId =  this.IsInternalAdmin && mainChildRegion !== undefined ? this.cryptoService.aesEncrypt(mainChildRegion.Id) : this.cryptoService.aesEncrypt(this.ReadRegionParam.MspMainRegionId) ;
        this.totalDeviceUsage = deviceusage_amount;
        this.NonParentRegion = mspRegion.filter((i) => i.ParentRegionId < 0 && i.MspMainRegionId !== i.Id).map((i, index) => {
          if (index === 0) {
            this.AddHierarchyParams = {
              ...this.AddHierarchyParams,
              childCompany: i.Id,
            };
          }
          return { label: i.RegionName, value: i.Id };
        });
        if (distributorData !== undefined) {
          this.customer = [];
          this.CompanyTargetOptions = [];
          this.CompanyTargetOptions.push({ label: '', value: 0 });
            if (distributorData.Customers !== undefined && distributorData.Customers.length > 0) {
              // this.isDistributor = true;
              this.unActiveCompanyNPM = 0;
              distributorData.Customers.map((c) => {
                if (c !== undefined) {
                  const obj = {
                    id: this.ReadRegionParam.MspMainRegionId === c.Id ? this.ReadRegionParam.MspMainRegionId.toString() : this.ReadRegionParam.MspMainRegionId.toString() + ',' + c.Id.toString(),
                    isDistributor: true
                  };
                  const hashObj = this.cryptoService.aesEncrypt(obj);
                  const UsedDevice = this.deviceUsage_list_dic[c.Id] !== undefined ? this.deviceUsage_list_dic[c.Id].data.total_quantity : 0;
                  const NpmBank = c.Nodes !== null ? c.Nodes : 0;
                  if (this.payment_regionId_dic[c.PaymentRegionId] === undefined) {
                    this.payment_regionId_dic[c.PaymentRegionId] = []
                  }
                  if (c.PROStatus !== 0) {
                    if (!this.payment_regionId_dic[c.PaymentRegionId].includes(c.Id)) {
                      this.payment_regionId_dic[c.PaymentRegionId].push(c.Id);
                    }
                  }
                  if (this.region_docDay_dic[c.PaymentRegionId] === undefined) {
                    this.region_docDay_dic[c.PaymentRegionId] = c.DocDay
                  }
                  const item = {
                    HashObj: hashObj,
                    RegionName: c.RegionName,
                    UsedDevice: UsedDevice,
                    CreateTime: this.fomatDate(c.CreateTime * 1000),
                    Admins: c.Admins,
                    Account: c.Admins !== undefined ? c.Admins.join(',') : '',
                    NpmBank: (c.PaymentRegionId === c.Id) ? NpmBank : '-',
                    NpmBankWarning: (c.PaymentRegionId === c.Id) ? (NpmBank < (c.MinCharge * 3)) : false,
                    NpmBankWarningMonth: (c.PaymentRegionId === c.Id) ? ((NpmBank < (c.MinCharge * 3) && NpmBank >= (c.MinCharge * 2)) ? 3 : ((NpmBank < (c.MinCharge * 2) && NpmBank >= c.MinCharge) ? 2 : ((NpmBank < c.MinCharge) ? 1 : 0))) : 0,
                    PROStatus: c.PROStatus,
                    Status: PROStatus[c.PROStatus] !== undefined ? PROStatus[c.PROStatus] : '--',
                    // OwnerAcode: region != undefined ? region.OwnerAcode : 0,
                    OwnerAccount: c.OwnerAccount ? c.OwnerAccount : '',
                    Id: c.Id,
                    PaymentRegionId: c.PaymentRegionId,
                    Type: c.PaymentRegionId === c.Id ? 1 : 0
                  };
                  const option = {
                    label: c.RegionName,
                    value: c.Id,
                    nodes: NpmBank
                  };
                  this.customer.push(item);
                  if (c.PaymentRegionId == c.Id && c.PROStatus === PROStatusIndex.Activated) {
                    this.CompanyTargetOptions.push(option);
                  }

                  if (c.PROStatus === PROStatusIndex.Created || c.PROStatus === PROStatusIndex.Waiting) {
                    this.unActiveCompanyNPM = this.unActiveCompanyNPM + NpmBank
                  }
                  this.accountActivityNodeBank_Dic[c.Id] = NpmBank;
                  this.AccountAcitvityFilter();
                }
              });
              if (this.CompanyOptions.length > 0) {
                const new_company_option = []
                for (const i in this.CompanyOptions) {
                  if (this.CompanyOptions[i] !== undefined && (!this.CompanyOptions[i].isCustomer || this.payment_regionId_dic[this.CompanyOptions[i].value] !== undefined)) {
                    new_company_option.push(this.CompanyOptions[i])
                  }
                }
                this.CompanyOptions = new_company_option;
              }
            }
        }
        if (regionHierarchy !== undefined && regionHierarchy.length > 0) {
          const mapHierarchyNode = (item) => {
            const children = item.children || [];
            return {
              ...item,
              deviceUsage: mspDeviceUsage_list.deviceUsage_dic[item.Id] !== undefined
                ? mspDeviceUsage_list.deviceUsage_dic[item.Id].DeviceUsage
                : 0,
              expanded: children.length === 0 ? false : item.expanded,
              children: children.map((child) => mapHierarchyNode(child)),
            };
          };
          this.hierarchyDataTree = regionHierarchy.map((item) => mapHierarchyNode(item));
        }
      }
    });

    this.store.select(fromStore.getMspRegionPayment).pipe(takeUntil(this.componentDestroyed)).subscribe((res) => {
      if ((res !== undefined && res !== null)) {
        const regionId = (this.IsSuperAdmin || this.IsRegionAdmin) ? this.mspRegionId : this.regionId;
        if (res.payment_list && res.payment_list.length > 0) {
          res.payment_list.map((item) => {
            this.accountActivityNodeBank_Dic[item.MspRegionId] = item.Nodes;
          });
        }
        const payment_setting = this.GetPaymentSettingByRegionId(res.payment_list, regionId);
        if (payment_setting !== undefined && payment_setting !== null) {
          this.paymentUnitPrice = payment_setting.UnitPrice;
          this.PROPaymentSetting.CurrentNPMBank = payment_setting.Nodes != undefined ? payment_setting.Nodes : 0;
          this.PROPaymentSetting.DocDay = payment_setting.DocDay
          this.PROPaymentSetting.UserChargeType = payment_setting.ChargeType;
          this.PROPaymentSetting.PaymentRegionId = payment_setting.PaymentRegionId;
          if (!this.payment_regionId_dic[payment_setting.PaymentRegionId]) {
            this.payment_regionId_dic[payment_setting.PaymentRegionId] = [];
          }
          if (!this.payment_regionId_dic[payment_setting.PaymentRegionId].includes(payment_setting.PaymentRegionId)) {
            this.payment_regionId_dic[payment_setting.PaymentRegionId].push(payment_setting.PaymentRegionId);
          }
          this.AccountAcitvityFilter();
          this.getPredictedNPMUsageData();
        }
      }
    });

    this.store.select(fromStore.getMspCustomerRegionPaymentByDistributor).pipe(takeUntil(this.componentDestroyed)).subscribe((res) => {
      if ((res && res.Loaded && !res.Loading)) {
        const proNodesParam = { ...this.getProNodesParam, RegionIds: res.RegionIdList };
        this.getProNodesParam = proNodesParam;
        this.store.dispatch(new fromFeature.GetProNodesBank(proNodesParam));
      }
    });
    
    this.store.select(fromStore.getPayPalAgreementApprovalUrl).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      if (res && res.isLoaded && !res.isLoading) {
        if (res.approval_url && res.approval_url !== '') {
          this.store.dispatch(new fromFeature.ResetPayPalAgreementApprovalUrlAction());
          window.location.href = res.approval_url;
        } else {
          this.ngxService.stop();
        }
      }
    });

    router.events.subscribe(s => {
      if (s instanceof NavigationEnd) {
        if (s.url.indexOf('?') !== -1) {
          const params = new URLSearchParams(s.url.split('?')[1]);
          const regionId = params.get('region');
          const status = params.get('status');
          const token = params.get('token');
          const ba_token = params.get('ba_token');
          if (status === 'success' && regionId && token && ba_token) {
            // remove redirect param
            window.history.pushState({}, document.title, '/purchase' + urlPath.ProManagementCompany );
            const PayPalAgreementparam = {
              Token: token,
              BaToken: ba_token,
              RegionId: parseInt(regionId),
            };
            this.store.dispatch(new fromFeature.ActivatePayPalAgreement(PayPalAgreementparam));
          } else if (status === 'cancel') {
            window.history.pushState({}, document.title, '/purchase' + urlPath.ProManagementCompany );
          } else {

          }
        }
      }
    });

  }

  ngOnInit() {
    this.region = [];
    this.totalDeviceUsage = 0;
    this.selectedNode = null;
    this.initDialogInput();
    this.initHierarchyDialogInput();
    this.companyPlanConfirm = {
      Id: NaN,
      IsMsp: false,
      MspDeviceLimit: NaN,
      // MspPlanLevel: NaN,
      MspPlanTime: NaN,
      MspPlanMgtId: NaN,
      MspPlanName: '',
    };
    this.getMspRegion();
    this.initTransferDialogInput();
    this.initAddCustomerDialogInput();
    this.initPayByCardDialogInput();
    // this.getRegionHierarchy();
  }

  private patchReadRegionParam(patch: Partial<typeof this.ReadRegionParam>): void {
    this.ReadRegionParam = { ...this.ReadRegionParam, ...patch };
  }

  private dispatchGetMspRegions(): void {
    if (this.ReadRegionParam !== undefined) {
      this.store.dispatch(new fromFeature.GetMspRegions({ ...this.ReadRegionParam }));
    }
  }

  private resetUpdateInfoState(type: string = updateInfoType.FreeState): void {
    this.UpdateInfoParam = { ...this.UpdateInfoParam, type };
    this.store.dispatch(new fromFeature.UpdateInfoSuccessAction({ ...this.UpdateInfoParam }));
  }

  private dispatchUpdateInfoAction(type: string): void {
    this.UpdateInfoParam = { ...this.UpdateInfoParam, type };
    this.store.dispatch(new fromMyfeatures.UpdateInfoAction({ ...this.UpdateInfoParam }));
  }

  getMspRegion() {
    if (this.ReadRegionParam !== undefined) {
    this.ngxService.start();
    this.dispatchGetMspRegions();
    }
  }

  ngOnDestroy() {
    this.componentDestroyed.next(undefined);
    this.componentDestroyed.unsubscribe();
  }

  // 2025-07-31 kyrie 手動Activate MSP功能移除
  // showActivateCompanyPlanConfirmDialog(data) {
  //   this.activateCompanyPlanConfirmDialog = true;
  //   this.companyPlanConfirm = {
  //     Id: data.Id,
  //     IsMsp: data.IsMsp,
  //     MspDeviceLimit: data.MspDeviceLimit,
  //     // MspPlanLevel: data.MspPlanLevel,
  //     MspPlanTime: data.MspPlanTime,
  //     MspPlanMgtId: data.MspPlanMgtId,
  //     MspPlanName: this.planMgtDic[data.MspPlanMgtId],
  //   };
  // }

  // activateCompanyPlan(regionId) {
  //   const param = {
  //     region_id: regionId
  //   };
  //   this.store.dispatch(new fromMyfeatures.ActivateCompanyMember(param));
  // }

  goBack(): void {
    this.location.back();
  }

  onTabChange(event) {
    this.selectDefaultTab = event;
  }

  initDialogInput() {
    this.dialogInput = {
      name: '',
      RegionName: '',
      UpdateType: 'Add Company',
      Note: '',
      Id: NaN,
      Admins: [],
      MSPAdmin: NaN,
      Domain: '',
      EnableDomain: false,
      SSOEnable: false,
      SAMLCertFile: '',
      Identifier: '',
      ReplyUrl: '',
      LoginUrl: '',
      MspDomain: '',
      SSOEntityId: ''
    };
    this.SAMLCertFileToUpload = null;
  }

  showDialog() {
    this.disableMainMSPAdminDropdown = false;
    this.selectDefaultTab = '0';
    this.adminSettingsDialog = true;
    this.pendingEditAdmins = null;
    this.initDialogInput();
    this.myRootInputVariable.nativeElement.value = '';
  }

  /** options 就緒後再套用 Edit 時的已選 Account Manager，避免顯示 null */
  private applyPendingEditAdmins() {
    if (this.pendingEditAdmins === null || !this.dialogInput) {
      return;
    }
    const validValues = new Set((this.adminsOptions || []).map(opt => opt.value));
    this.dialogInput = {
      ...this.dialogInput,
      Admins: this.pendingEditAdmins.filter(v => v != null && !Number.isNaN(v) && validValues.has(v))
    };
    this.pendingEditAdmins = null;
  }

  showEditDialog() {
    // this.showMainMSPAdminDropdownList = false;
    this.disableMainMSPAdminDropdown = false;
    this.selectDefaultTab = '0';
    this.adminSettingsDialog = true;
    this.adminsOptions = [];
    this.MSPAdminOptions = [];
    this.selectedNode = this.selectedRegion.data;
    const admins = this.selectedNode.Admins !== undefined
      ? this.selectedNode.Admins.filter(s => s != null && s !== this.selectedNode.MainAdmin)
      : [];
    if (this.selectedNode.CreateId !== undefined && !admins.includes(this.selectedNode.CreateId) &&
     this.selectedNode.Id !== this.selectedNode.MspMainRegionId) {
      admins.push(this.selectedNode.CreateId);
    }
    // 先不寫入 Admins，等 ReadCompanyMember 回傳 options 再套用，避免短暫顯示 null
    this.pendingEditAdmins = [...admins].sort(function (a: any, b: any) {
      return a - b;
    });
    this.dialogInput = {
      Id: this.selectedNode.Id,
      name: this.selectedNode.Region,
      RegionName: this.selectedNode.RegionName,
      UpdateType: 'Edit Company',
      Note: this.selectedNode.Note,
      Admins: [],
      MSPAdmin: this.selectedNode.MainAdmin,
      EnableDomain: this.selectedNode.EnableDomain === 1 ? true : false,
      SSOEnable: (this.selectedNode.SSOEnable !== undefined && this.selectedNode.SSOEnable !== null) ? this.selectedNode.SSOEnable : false,
      SAMLCertFile: this.selectedNode.SAMLCertFile,
      Domain: this.selectedNode.Domain,
      Identifier: this.selectedNode.Identifier,
      ReplyUrl: this.selectedNode.ReplyUrl,
      LoginUrl: this.selectedNode.SAMLLoginURL,
      MspDomain: this.selectedNode.MspDomain,
      SSOEntityId: this.selectedNode.SSOEntityId
    };
    if (this.dialogInput.MSPAdmin !== undefined && this.dialogInput.MSPAdmin !== null && !isNaN(this.dialogInput.MSPAdmin)) {
      this.disableMainMSPAdminDropdown = true;
    }
    // if (this.selectedNode.Id == this.selectedNode.MspMainRegionId) {
    //   this.showMainMSPAdminDropdownList = true;
    // }
    this.store.dispatch(new fromMyfeatures.ReadCompanyMember(this.selectedNode.Id));
    this.myRootInputVariable.nativeElement.value = '';
    this.SAMLCertFileToUpload = null;
    this.updateIdentifierAndReplyUrl(this.dialogInput.SSOEnable);
    this.getMspRegion();
  }

  updateIdentifierAndReplyUrl(isShow) {
    if (isShow) {
      this.dialogInput.Identifier =
       environment.IdentifierUrl.replace('{0}', this.dialogInput.SSOEntityId ? this.dialogInput.SSOEntityId : '');
      this.dialogInput.ReplyUrl = environment.ReplyUrl;
    } else {
      this.dialogInput.Identifier = '';
      this.dialogInput.ReplyUrl = '';
    }
  }

  selectedActiveSSO(event) {
    // PrimeNG 20 Checkbox onChange 傳入 CheckboxChangeEvent
    const checked = typeof event === 'boolean' ? event : !!event?.checked;
    this.dialogInput = { ...this.dialogInput, SSOEnable: checked };
    this.updateIdentifierAndReplyUrl(checked);
  }

  handleFileInput(event: any) {
    if (event.target.name === ssoType.SamlCertificate) {
      this.SAMLCertFileToUpload = event.target.files[0];
      const files = event.target.files;
      const f = files[0];
      const reader = new FileReader();

      reader.readAsText(f);
      reader.onload = (f => {
        return e => {
          this.ssoFileContainer =
           e.target.result.toString().replace(/-----BEGIN CERTIFICATE-----/g, '').replace(/-----END CERTIFICATE-----/g, '');
        };
      })(f);
    }
  }

  saveSSO() {
    const self = this;
    const fileArr = [];
    this.ngxService.start();
    if (this.SAMLCertFileToUpload != null) {
      fileArr.push({
        name: ssoType.SamlCertificate,
        file: this.SAMLCertFileToUpload,
      });
    }
    this.store.dispatch(new fromFeature.GetAzureBlobStoragesSASToken());
    setTimeout(() => {
      if (fileArr.length !== 0) {
        let count = 0;
        // tslint:disable-next-line: forin
        for (const i in fileArr) {
          const file = fileArr[i].file;
          if (this.dialogInput.name === null || this.dialogInput.name === '') {
            alert('Please check the field.');
            this.ngxService.stop();
            return;
          }
          if (this.powerMaster && isNaN(this.dialogInput.Id)) {
            if (file === null || typeof file === 'undefined') {
              alert('Please check the field.');
              this.ngxService.stop();
              return;
            }
          }

          if (file !== null && typeof file !== 'undefined') {
            if (fileArr[i].name != 'Upload Certification') {
              if (!file.name.toLowerCase().includes('.cer')) {
                alert('Please check the ' + fileArr[i].name + '.');
                this.ngxService.stop();
                return;
              }
            }
            const param: AzureBlobStorageParam = {
              name: file.name,
              path: fileArr[i].name.replace(' ', ''),
              file: file,
              timestamp: new Date().getTime().toString().substr(0, 10),
              container: containerType.Region,
            };
            this.store.dispatch(
              new fromFeature.GetUploadAzureBlobStorages(param)
            );
            if (fileArr[i].name == ssoType.SamlCertificate) {
              this.dialogInput.SAMLCertFile =
                '/' +
                containerType.Region +
                '/' +
                fileArr[i].name.replace(' ', '') +
                '/' +
                param.timestamp +
                '/' +
                file.name;
            }
            count = parseInt(i) + 1;
          }
          if (count === fileArr.length || fileArr.length === 0) {
            this.saveAdminSetting();
          }
        }
      } else {
        this.saveAdminSetting();
      }
    }, 1000);
  }

  saveAdminSetting(confirmSave: boolean = false) {
    const params: MspRegion = {
      MspMainRegionId: this.ReadRegionParam.MspMainRegionId,
      RegionName: this.dialogInput.RegionName,
      Note: ''
    };
    if (params.RegionName === '') {
      let msg = '';
      msg += 'Company Name \n';
      if (msg !== '') {
        alert('Please check : \n' + msg);
        this.ngxService.stop();
        return;
      }
    }
    if (isNaN(this.dialogInput.Id)) {
      this.store.dispatch(new fromMyfeatures.AddMspRegion(params));
    } else {
      if (!confirmSave && this.ReadRegionParam.MspMainRegionId === this.dialogInput.Id && this.dialogInput.Admins.length === 0) {
        this.adminSettingsDialog = false;
        this.confirmSaveAdminDialog = true;
        this.ngxService.stop();
      } else {
        if (isNaN(this.dialogInput.MSPAdmin)) {
          let msg = '';
          msg += 'Main MSP Admin \n';
          if (msg !== '') {
            alert('Please check : \n' + msg);
            this.ngxService.stop();
            return;
          }
        }

        if (this.dialogInput.SSOEnable) {
          if (this.dialogInput.MspDomain === '' || this.dialogInput.MspDomain === null) {
            let msg = '';
            msg += 'Domain \n';
            if (msg !== '') {
              alert('Please check : \n' + msg);
              this.ngxService.stop();
              return;
            }
          }
          if (this.dialogInput.LoginUrl === '' || this.dialogInput.LoginUrl === null) {
            let msg = '';
            msg += 'Login Url \n';
            if (msg !== '') {
              alert('Please check : \n' + msg);
              this.ngxService.stop();
              return;
            }
          }
          if (this.dialogInput.SAMLCertFile === '' || this.dialogInput.SAMLCertFile === null) {
            let msg = '';
            msg += 'Upload Certification \n';
            if (msg !== '') {
              alert('Please check : \n' + msg);
              this.ngxService.stop();
              return;
            }
          }
        }
        const admins = (this.selectedNode !== null && this.selectedNode.Id !== this.selectedNode.MspMainRegionId) ? this.dialogInput.Admins.filter(i => i !== this.selectedNode.CreateId) : this.dialogInput.Admins;
        const update: Update<MspRegion> = {
          id: this.dialogInput.Id,
          changes: {
            RegionId: this.dialogInput.Id,
            RegionName: this.dialogInput.RegionName,
            Note: '',
            MspDomain: this.dialogInput.MspDomain,
            MainAdmin: this.dialogInput.MSPAdmin,
            Admins: admins,
            SSOEnable: this.dialogInput.SSOEnable ? this.dialogInput.SSOEnable : false,
            SAMLLoginURL: this.dialogInput.LoginUrl,
            SAMLCert: this.cryptoService.aesEncrypt(this.ssoFileContainer),
            SAMLCertFile: this.dialogInput.SAMLCertFile,
            // Region: this.dialogInput.name,
            // Domain: this.dialogInput.Domain,
            // MSPAdmin: this.dialogInput.MSPAdmin,
            // EnableDomain: this.dialogInput.EnableDomain,
            // LoginUrl: this.dialogInput.LoginUrl,
          },
        };
        this.store.dispatch(new fromMyfeatures.UpdateMspRegion(update));
        this.confirmSaveAdminDialog = false;
      }
    }
    this.selectedNode = null;
    this.adminSettingsDialog = false;
    // this.ngxService.stop();
  }

  // Confirm Company Limit
  showGenerateCompanyPlanConfirmDialog() {
    this.generateCompanyPlanConfirmDialog = true;
    this.adminSettingsDialog = false;
    this.ngxService.stop();
  }

  showDeleteRegion() {
    this.deleteRegionDialog = true;
    this.selectedRegionName = this.selectedRegion.data.RegionName;
    this.selectedNode = this.selectedRegion.data;
  }

  deleteRegion() {
    this.deleteRegionDialog = false;
    // If region has Account or Hierarchy or License, then it can't be delete;
    if (
      this.account.find((i) => i.CompanyId === this.selectedNode.Id && this.selectedNode.MainAdmin !== i.Acode) || // No Account
      this.selectedNode.ParentRegionId > 0 || // No Hierarchy
      this.licenseMgtList.find((i) => i.RegionId === this.selectedNode.Id) // It has license
    ) {
      this.messageService.add({
        severity: 'error',
        summary: 'Please check data.',
      });
      this.clearMessageService();
      this.ngxService.stop();
      return;
    }
    this.store.dispatch(
      new fromMyfeatures.DeleteRegions({ Id: this.selectedNode.Id })
    );
    this.selectedNode = null;
  }

  downloadAzureBlobStorage(path) {
    this.store.dispatch(new fromFeature.GetAzureBlobStoragesSASToken());
    setTimeout(() => {
      const pathSplit = (path) ? path.split('/') : null;
      const param: AzureBlobStorageParam = {
        name: (pathSplit) ? pathSplit[4] : '',
        path: (pathSplit) ? pathSplit[2] : '',
        // token: '',
        timestamp: (pathSplit) ? pathSplit[3] : '',
        container: containerType.Region
      };
      this.store.dispatch(new fromFeature.GetDownLoadAzureBlobStorages(param));
    }, 1000);
  }

  saveFile(data) {
    // url轉換'%2F'為'/'
    const fileUrlArr = data.url.split('?');
    fileUrlArr[0] = fileUrlArr[0].replace(/\%2F/g, '/');
    const url = fileUrlArr.join('?');
    window.open(url);
  }

  // Hierarchy----------------------
  onNodeSelect(event) {
    this.AddHierarchyParams = {
      ...this.AddHierarchyParams,
      companySource: this.selectedFile.Id,
    };
    this.IsSelectedCompanyHierarchyMsp = false;
    // if (this.IsSuperAdmin) {
    //   const regionFind = this.region.find(i => i.IsMsp != null && i.Id === this.selectedFile.Id);
    //   if (typeof regionFind !== 'undefined' && regionFind !== null) {
    //     if (typeof regionFind.IsMsp !== 'undefined' && regionFind.IsMsp !== null) {
    //       this.IsSelectedCompanyHierarchyMsp = regionFind.IsMsp;
    //     }
    //   }
    // }
  }

  initHierarchyDialogInput() {
    this.hierarchydialogInput = {
      UpdateType: 'Add Company Hierarchy',
    };
  }

  showHierarchyDialog() {
    this.hierarchyDialog = true;
    this.editHierarchyStatus = false;
    this.initHierarchyDialogInput();
  }

  showAddCompanyMemberDialog(selectedRegionName, selectedRegionId, selectedParentRegionId) {
    this.globalIsClickMemberbutton = true;
    this.globalSelectedRegionName = selectedRegionName;
    this.globalSelectedRegionId = selectedRegionId;
    this.globalSelectedParentRegionId = selectedParentRegionId;
    this.childDialog.companyMemberList = [];
    this.store.dispatch(new fromMyfeatures.ReadCompanyMember(selectedRegionId));
  }

  showDeleteHierarchyDialog() {
    this.displayHierarchyConfirmDialog = true;
  }

  showHierarchyEditDialog() {
    this.hierarchyDialog = true;
    this.hierarchydialogInput = {
      UpdateType: 'Edit Company Hierarchy',
    };
    this.editHierarchyStatus = true;
  }

  deleteFromHierarchy() {
    if (this.selectedFile.Id === 1) {
      // Default
      this.messageService.add({
        severity: 'error',
        summary: 'Default data can not be deleted.',
      });
      this.clearMessageService();
      return;
    }
    if (!this.selectedFile || this.selectedFile.children.length > 0) {
      this.messageService.add({
        severity: 'error',
        summary: 'Default data can not be have children region.',
      });
      this.clearMessageService();
      return;
    }
    this.ngxService.start();
    const update: Update<MspRegion> = {
      id: this.selectedFile.Id,
      changes: {
        RegionId: this.selectedFile.Id,
        ParentRegionId: -1,
      },
    };
    this.store.dispatch(new fromMyfeatures.UpdateMspRegion(update));
    this.selectedFile = null;
    this.displayHierarchyConfirmDialog = false;
  }

  saveHierarchy() {
    if (
      this.AddHierarchyParams.companySource <= 0 ||
      this.AddHierarchyParams.childCompany <= 0
    ) {
      this.messageService.add({ severity: 'error', summary: 'Error' });
      this.clearMessageService();
      return;
    }
    this.ngxService.start();
    const update: Update<MspRegion> = {
      id: this.AddHierarchyParams.childCompany,
      changes: {
        RegionId: this.AddHierarchyParams.childCompany,
        ParentRegionId: this.AddHierarchyParams.companySource,
      }
    };
    this.dispatchUpdateInfoAction(updateInfoType.EditRegion);
    this.store.dispatch(new fromMyfeatures.UpdateMspRegion(update));
    this.selectedFile = null;
    this.hierarchyDialog = false;
  }

  controlCompanyMember(result: string) {
    if (result === 'addCompanyMember' || result === 'ImportCompanyMember' || result === 'DeleteCompanyMember') {
      switch (result) {
        case 'addCompanyMember':
          // this.childDialog.CompanyName = '';
          const checkErrorParam = {
            Account: this.childDialog.memberEmailInput,
            RespType: '0',
            SelectCompanyName: this.globalSelectedRegionName
          };
          // 過濾條件0: 是否輸入重複的 email
          let checkEmailIsRepeatResult = false;
          const findEmailRes = this.childDialog.companyMemberList.find(element => element.account === this.childDialog.memberEmailInput);
          if (typeof findEmailRes !== 'undefined' && findEmailRes !== null) {
            checkEmailIsRepeatResult = true;
          }
          if (checkEmailIsRepeatResult) {
            // 重複了 顯示錯誤訊息
            // ShareModel.CheckCompanyMember ErrorMsg number 4: 此 Account 已被加入Member
            checkErrorParam.RespType = '4';
            this.childDialog.errorCompanyMember(checkErrorParam);
            break;
          }

          // 過濾條件1: email的domain與現有 member list 內的 domain 相同 (只比對 list 內第一個)
          let checkSameMemberDomainResult = false;
          try {
            const mList = this.childDialog.companyMemberList;
            if (mList.length === 0) {
              checkSameMemberDomainResult = true;
            } else {
              const firstMemberEmailDomain = mList[0].account.split('@');
              const memberEmailInputDomainSplit = this.childDialog.memberEmailInput.split('@');
              if (firstMemberEmailDomain.length > 1 && memberEmailInputDomainSplit.length > 1) {
                if (firstMemberEmailDomain[1] == memberEmailInputDomainSplit[1]) {
                  checkSameMemberDomainResult = true;
                }
              }
            }
          } catch (error) {
            console.log('exception: controlCompanyMember() => checkSameMemberDomainResult');
          }
          if (!checkSameMemberDomainResult) {
            // 過濾條件1失敗 顯示錯誤訊息
            // ShareModel.CheckCompanyMember ErrorMsg number 5: 此email的domain與 現有 member list 內的 domain 不同
            checkErrorParam.RespType = '5';
            this.childDialog.errorCompanyMember(checkErrorParam);
            break;
          }

          // 過濾條件2: email的domain是否有效, 是否與 local admin 的 domain 相同 (只比對 list 內第一個)
          // let domainEmailCompareResult = false;
          // try {
          //   const regionFind = this.region.find(i => i.Id === this.childDialog.RegionId);
          //   if (typeof regionFind !== 'undefined' && regionFind !== null) {

          //     // 若 Admins 未指定, 直接給過, 因為需要加入任意 member 用來指定 Admin
          //     if (regionFind.Admins === undefined || regionFind.Admins === null || regionFind.Admins.length === 0) {
          //       domainEmailCompareResult = true;
          //     } else {
          //       const firstAdminEmailArray = regionFind.account.split('/');
          //       const firstAdminEmail = firstAdminEmailArray.length > 0 ? firstAdminEmailArray[0] : '';
          //       const firstAdminEmailDomainSplit = firstAdminEmail.split('@');
          //       const memberEmailInputDomainSplit = this.childDialog.memberEmailInput.split('@');
          //       if (firstAdminEmailDomainSplit.length > 1 && memberEmailInputDomainSplit.length > 1) {
          //         if (firstAdminEmailDomainSplit[1] == memberEmailInputDomainSplit[1]) {
          //           domainEmailCompareResult = true;
          //         }
          //       }
          //     }
          //   }
          // } catch (error) {
          //   console.log('exception: controlCompanyMember() => domainEmailCompareResult');
          // }
          // if (!domainEmailCompareResult) {
          //   // 過濾條件2失敗 顯示錯誤訊息
          //   // ShareModel.CheckCompanyMember ErrorMsg number 6: 此email的domain與現有local admin的 domain 不同
          //   checkErrorParam.RespType= "6"
          //   this.childDialog.errorCompanyMember(checkErrorParam);
          //   break;
          // }

          // Acccount過濾條件3失敗 顯示錯誤訊息
          // 不存在此 Account
          // 己存在於其它 MSP 公司
          // 此 Account 不屬於原 Region 下
          // 此 Account 已被加入Member
          const param = {
            otp: '',
            Account: this.childDialog.memberEmailInput,
            RegionId: this.selectedRegion.data.Id
          };
          this.store.dispatch(new fromFeature.CheckCompanyMember(param));

          break;
        case 'ImportCompanyMember':
          break;
        case 'DeleteCompanyMember':
          break;
      }
    }
  }

  saveCompanyMember(result: string) {
    switch (result) {
      case 'saveCompanyMember':
        this.childDialog.dialogType.CompanyMemberListDialog = false;
        const mailTemp = [];
        if (this.childDialog.companyMemberList.length > 0) {
          this.childDialog.companyMemberList.forEach((item) => {
            mailTemp.push(item.account);
          });
        }
        // 將子公司自動新增的MainMspRegion加回memberlist
        if (this.mainMspAdmin !== undefined && this.mainMspAdmin !== '') {
          mailTemp.push(this.mainMspAdmin);
        } else {
          const mainMspAdmin = 'Region_' + this.childDialog.RegionId + '@cyberpower.com';
          mailTemp.push(mainMspAdmin);
        }
        const param = {
          mail: mailTemp,
          region_id: this.childDialog.RegionId
        };
        this.store.dispatch(new fromMyfeatures.UpdateCompanyMember(param));
        this.ngxService.start();
        break;
    }
  }

  // showAddAuthority(selectedRegionName, selectedRegionId, selectedParentRegionId) {
  //   this.router.navigate(['/management/admin/authority']);
  //   this.apiService.setSelectedRegionName(selectedRegionName);
  // }

  showAddAuthority() {
    let paramStr = '';
    // MspMainRegionId , SelectedRegionId
    paramStr = `${this.selectedRegion.data.MspMainRegionId},${this.selectedRegion.data.Id}`;
    const hashStr = this.cryptoService.aesEncrypt(paramStr);
    this.router.navigate(['management/pro/account/' + hashStr]);
  }

  showUsedDeviceDetail() {
    this.router.navigate(['management/admin/pro/used-device-detail/' + this.hashMspUsageRegionId]);
  }

  showUsedDeviceHistory(selectedHashRegionId) {
    this.router.navigate(['management/admin/pro/used-device-history/' + selectedHashRegionId]);
  }

  showSmartPowerReport(selectRegionid) {
    const paramStr = 'MspAdmin,' + this.mspRegionId + ',' + selectRegionid
    const hashStr = this.cryptoService.aesEncrypt(paramStr);
    this.router.navigate(['management/smart-power-report', hashStr]);
  }

  onPanelShow() {
    this.inheritDialog = true;
  }

  onPanelHide() {
    this.inheritDialog = false;
  }
  clearMessageService() {
    setTimeout(() => {
      this.messageService.clear();
    }, 2000);
  }
  getDefaultDate() {
    const today = new Date();
    const preDate = new Date(today);
    this.datePickStart = preDate;
    this.generateMonths();
    this.selectedMonth = today.getMonth() + 1;
  }

  fomatDate(value) {
    const dateObject = new Date(value);
    const year = dateObject.getFullYear();
    const month = ('0' + (dateObject.getMonth() + 1)).slice(-2); // 月份是從0開始的，所以要加1
    const day = ('0' + dateObject.getDate()).slice(-2);
    const hours = ('0' + dateObject.getHours()).slice(-2);
    const minutes = ('0' + dateObject.getMinutes()).slice(-2);
    const seconds = ('0' + dateObject.getSeconds()).slice(-2);
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  // 將資料轉換成TreeTable格式
  getTreeRegion() {
    const regionMap = new Map<number, any>();
    this.treeRegion = this.region.map(i => ({
      data: i,
      children: [],
      expanded: true
    })) as any[];

    this.treeRegion.forEach(node => {
      regionMap.set(node.data.Id, node);
    });

    let transformedRegion: any[] = [];
    this.treeRegion.forEach(node => {
      const parentId = node.data.ParentRegionId;
      const mainRegionId = node.data.MspMainRegionId;
      if (node.data.Id === parentId || node.data.Id === mainRegionId) {
        transformedRegion.push(node);
      } else {
        const parentNode = regionMap.get(parentId);
        if (parentNode) {
          parentNode.children.push(node);
        } else {
          transformedRegion.push(node);
        }
      }
    });

    this.treeRegion = transformedRegion;
  }

  getVisibleColumnsCount(): number {
    return this.regionTable_cols.filter(col => col.visible === true).length;
  }

  toggleShowAll(node: any): void {
    node.showAllAdmins = !node.showAllAdmins;
  }

  generateMonths() {
    this.monthOptions = [];
    for (let i = 0; i < 12; i++) {
      this.monthOptions.push({ label: monthMap[i + 1], value: i + 1 });
    }
  }

  generateYearOptions() {
    const yearMap: { [year: number]: boolean } = {};
    this.accountActivityListAll.forEach(item => {
      const date = new Date(item.CreateTime * 1000);
      if (!isNaN(date.getTime())) {
        const year = date.getFullYear();
        yearMap[year] = true;
      }
    });
    const yearOptions = Object.keys(yearMap).map(Number).sort((a, b) => b - a);
    this.yearOptions = [{ label: 'All', value: 0 },...yearOptions.map(year => ({ label: year.toString(), value: year }))];
  }

  AccountAcitvityFilter() {
    this.accountActivityList = this.accountActivityListAll;
    // 2025/09/25 kyrie: NPM Bank會隨著SelectedCompany變動
    if (this.accountActivityNodeBank_Dic[this.selectedCompany] != undefined) {
      this.accountActivityNodeBank = this.accountActivityNodeBank_Dic[this.selectedCompany];
    }
    if ((this.IsSuperAdmin || this.IsRegionAdmin) 
      || (this.PROType === PROTypeIndex.Distributor && this.selectedCompany !== 0) 
      || (this.PROPaymentSetting.UserChargeType !== null)) {
      this.accountActivityList = this.accountActivityList.filter(item => {
        return item.RegionId === this.selectedCompany;
      });
      let lastmonth_npm_usage = 0
      if (this.accountActivityListAll.length > 0) {
        const now = new Date();
        const last_month = new Date();
        last_month.setMonth(now.getMonth() - 1);
        const last_month_ts = Math.floor(last_month.getTime() / 1000);
        this.accountActivityListAll.filter(s=>s.RegionId == this.selectedCompany && s.ActionType == 1 && s.CreateTime > last_month_ts).map(a => {
          if (a.Nodes !== undefined) {
            lastmonth_npm_usage = lastmonth_npm_usage + a.Nodes
          }
        })
      }
      this.predictedNPMUsage.LastDeviceUsage = lastmonth_npm_usage;
      if (this.payment_regionId_dic[this.selectedCompany] !== undefined) {
        this.predictedNPMUsage.PredictedDeviceUsage = 0;
        this.predictedNPMUsage.Growth = 0;
        for (const i in this.payment_regionId_dic[this.selectedCompany]) {
          if (this.deviceUsage_list_dic[this.payment_regionId_dic[this.selectedCompany][i]] !== undefined) {
            const item = this.deviceUsage_list_dic[this.payment_regionId_dic[this.selectedCompany][i]]
            this.predictedNPMUsage.PredictedDeviceUsage = this.predictedNPMUsage.PredictedDeviceUsage + item.data.total_quantity;
            // this.predictedNPMUsage.LastDeviceUsage = this.predictedNPMUsage.LastDeviceUsage + item.data.total_last_quantity;
          }
        }

        this.predictedNPMUsage.Growth = this.predictedNPMUsage.PredictedDeviceUsage - lastmonth_npm_usage;
        this.getPredictedNPMUsage(this.selectedCompany);
      }
      
      if (this.region_docDay_dic[this.selectedCompany] != undefined) {
        this.PROPaymentSetting.DocDay = this.region_docDay_dic[this.selectedCompany];
        this.getPredictedNPMUsageData();
      }
    }
    if (this.selectedYear !== 0) {
      this.accountActivityList = this.accountActivityList.filter(item => {
        const itemDate = new Date(item.CreateTime * 1000);
        return itemDate.getFullYear() === this.selectedYear;
      });
    }
    if (this.PROType === PROTypeIndex.Customer) {
      this.accountActivityList = this.accountActivityList.filter(item => {
        const itemDate = new Date(item.CreateTime * 1000);
        return itemDate.getMonth() + 1 === this.selectedMonth;
      });
    }
    if (this.selectedActionType !== 0) {
      this.accountActivityList = this.accountActivityList.filter(item => {
        return item.ActionTypeStr === this.ActionType[this.selectedActionType];
      });
    }
    if (this.table !== undefined) {
      this.table.reset();
    }
  }

  initTransferDialogInput() {
    this.transferDialogInput = {
      quantity: 0,
      source: this.regionId,
      target: 0,
      sourceNpm: this.mainChildRegionNpm,
      targetNpm: 0,
    };
  }

  showTransferNPMDialog() {
    this.dialogVisibility.transfer = true;
    this.initTransferDialogInput();
    this.disabledTransferConfirm();
    this.getCustomerNPM();
  }

  confirmTransfer() {
    this.ngxService.start();
    const param = {
      RegionId: this.transferDialogInput.target,
      Nodes: this.transferDialogInput.quantity
    };
    this.store.dispatch(new fromFeature.TransferProNodes(param));
    this.dialogVisibility.transfer = false;
  }

  getCompanyLabelById(id: any): string {
    const options = [...(this.CompanySourceOptions || []), ...(this.CompanyTargetOptions || [])];
    const found = options.find(opt => opt.value === id);
    return found ? found.label : id;
  }

  showAddCustomerDialog() {
    this.dialogVisibility.addCustomer = true;
    this.checkTransferAccountFail = false;
    this.checkTransferAccountResult = 0;
    this.addCustomerStepIndex = 1;
    this.initAddCustomerDialogInput();
  }

  showEditCustomerDialog() {
    this.dialogVisibility.editCustomer = true;
    this.addCustomerStepIndex = 1;
    this.addCustomerDialogInput = {
      UpdateType: 'Edit Customer',
      name: this.selectedCustomer.RegionName,
      account: this.selectedCustomer.Account,
      ownerAccount: this.selectedCustomer.OwnerAccount,
      status: this.selectedCustomer.PROStatus,
      type: this.selectedCustomer.Type,
      quantity: this.selectedCustomer.NpmBank,
    };
  }


  checkTransferButton() {
    if (this.selectedCustomer) {
      if (this.selectedCustomer.Status === 0) {
        return true;
      } else {
        return false;
      }
    }
  }

  checkDeleteCustomerDialog() {
    if (this.selectedCustomer.PaymentRegionId !== this.regionId && this.selectedCustomer.NpmBank < 0) {
      this.deleteWarningCustomerStepIndex = 1;
      this.dialogVisibility.deleteWarningCustomer = true;
    } else if (this.selectedCustomer.Admins.length === 0) {
      this.deleteWarningCustomerStepIndex = 2;
      this.dialogVisibility.deleteWarningCustomer = true;
    } else {
      this.showDeleteCustomerDialog();
    }
  }

  showDeleteCustomerDialog() {
    this.deleteCustomerStepIndex = 1;
    this.dialogVisibility.deleteCustomer = true;
    this.CustomerManagerOptions = this.selectedCustomer.Admins.map(item => {
      return {label: item, value: item};
    });
    this.deleteCustomerDialogInput = {
      Id: this.selectedCustomer.Id,
      name: this.selectedCustomer.RegionName,
      TargetAccount: this.CustomerManagerOptions[0].value,
    };
  }

  deleteCustomer() {
    const params = {
      Id: this.selectedCustomer.Id,
      TargetAccount: this.deleteCustomerDialogInput.TargetAccount
    };
    this.store.dispatch(new fromMyfeatures.DeleteRegions(params));

    this.dialogVisibility.deleteCustomer = false;
  }

  disabledTransferConfirm() {
    const quantity = Number(this.transferDialogInput.quantity)
    if (this.transferDialogInput.target === 0 
      || Number.isNaN(quantity) 
      || quantity <= 0 
      || this.transferDialogInput.sourceNpm < 0 
      || quantity > this.transferDialogInput.sourceNpm  
      || (this.transferDialogInput.sourceNpm - this.unActiveCompanyNPM - quantity) < 0) {
      this.disabledTransferConfirmButton = true;
    } else {
      this.disabledTransferConfirmButton = false;
    }
  }

  getCustomerNPM() {
    if (this.customer && this.customer.length > 0) {
      const targetId = this.transferDialogInput.target;
      const targetCompany = this.CompanyTargetOptions.find(c => c.value === targetId);
      if (targetCompany) {
        this.transferDialogInput.targetNpm = Number(targetCompany.nodes) || 0;
      } else {
        this.transferDialogInput.targetNpm = 0;
      }
    } else {
      this.transferDialogInput.targetNpm = 0;
    }

    this.transferDialogInput.quantity = Number(this.transferDialogInput.quantity) || 0;
  }

  getSourceAfterTransfer(): number {
    return (+this.PROPaymentSetting.CurrentNPMBank || 0) - (+this.unActiveCompanyNPM || 0) - (+this.transferDialogInput.quantity || 0);
  }

  getTargetAfterTransfer(): number {
    return (+this.transferDialogInput.targetNpm || 0) + (+this.transferDialogInput.quantity || 0);
  }

  addCustomerStep(step) {
    this.addCustomerStepIndex = step;
  }

  initAddCustomerDialogInput() {
    this.addCustomerDialogInput = {
      UpdateType: 'Add Customer',
      name: '',
      status: null,
      account: '',
      type: '0',
      quantity: 0,
      ownerAccount: ''
    };

    this.deleteCustomerDialogInput = {
      Id: 0,
      name: '',
      TargetAccount: '',
    };
  }


  disabledAddCustomerSave() {
    // console.log("addCustomerDialogInput: ", this.addCustomerDialogInput, this.accountActivityNodeBank, this.unActiveCompanyNPM)
    if (this.addCustomerDialogInput.name === '' || this.addCustomerDialogInput.ownerAccount === '' ||
      (this.addCustomerDialogInput.type === '1'
        && (this.addCustomerDialogInput.quantity == null
          || this.addCustomerDialogInput.quantity < 0 || (this.addCustomerDialogInput.quantity > 0 && (((this.accountActivityNodeBank - this.unActiveCompanyNPM) - this.addCustomerDialogInput.quantity) < 0))))
    ) {
      return true;
    } else {
      return false;
    }
  }
  disabledEditCustomerSave() {
    if (this.addCustomerDialogInput.name === '' || this.addCustomerDialogInput.ownerAccount === '') {
      return true;
    } else {
      return false;
    }
  }

  customerAccountOnChange() {
    if (this.addCustomerDialogInput.ownerAccount === '') {
      this.transferAccountError = false;
    }
  }

  checkTransferAccount() {
    const param = {
      otp: '',
      Account: this.addCustomerDialogInput.ownerAccount,
      RegionId: this.parentRegionId,
      IsTransfer: true
    };
    this.store.dispatch(new fromFeature.CheckCompanyMember(param));
  }

  initPayByCardDialogInput() {
    this.PayByCardDialogInput = {
      defaultTab: '0',
      type: '0',
      quantity: 0,
      paypalStatus: 0
    };
  }

  onPayByCardTabChange(event) {
    this.PayByCardDialogInput.defaultTab = event;
  }

  onPROPaymentSettingChange(init) {
    this.PROPaymentSetting.PaymentNPMBank = this.PROPaymentSetting.CurrentNPMBank >= 0 ? 0 : Math.abs(this.PROPaymentSetting.CurrentNPMBank);
    this.PayByCardDialogInput.quantity = (this.PayByCardDialogInput.type === '0') ? this.PROPaymentSetting.PaymentNPMBank : ((init) ? 0 : this.PayByCardDialogInput.quantity);
    this.PROPaymentSetting.TotalAmount = this.PayByCardDialogInput.quantity * this.paymentUnitPrice;
    this.PROPaymentSetting.AfterPayment = Number(this.PayByCardDialogInput.quantity) + Number(this.PROPaymentSetting.CurrentNPMBank);
    const isValid = (this.PayByCardDialogInput.quantity === 0) ? false : (this.PROPaymentSetting.PaymentNPMBank === 0 ? true : ((this.PayByCardDialogInput.quantity >= Math.abs(this.PROPaymentSetting.CurrentNPMBank)) ? true : false));
    this.isFormValid = isValid;

    // 檢查 actions 物件是否已經被 onInit 初始化
    if (this.paypalActions) {
      // 根據 isFormValid 的值來啟用或禁用按鈕
      if (this.isFormValid) {
        setTimeout(() => {
          this.paypalActions.enable();
        }, 100);
      } else {
        setTimeout(() => {
          this.paypalActions.disable();
        }, 100);
      }
    }
  }

  showPayByCardDialog () {
    this.dialogVisibility.PayByCard = true;
    this.initPayByCardDialogInput();
    if (this.PROPaymentSetting.UserChargeType === this.ChargeType.Monthly) {
      this.PayByCardDialogInput.defaultTab = '1';
    }
    this.renderPayPalButton();
    this.onPROPaymentSettingChange(true); // 
  }

  getPredictedNPMUsage(regionid : any = null) {
    if (regionid !== null) {
      this.predictedNPMUsage.PredictedBank = this.accountActivityNodeBank_Dic[regionid] - this.predictedNPMUsage.PredictedDeviceUsage;
    }else{
      this.predictedNPMUsage.PredictedBank = this.PROPaymentSetting.CurrentNPMBank - this.predictedNPMUsage.PredictedDeviceUsage;
    }
    this.predictedNPMUsageList = [this.predictedNPMUsage];
  }

  // getDisplayNpm(): number {
  //   return this.accountActivityNodeBank >= 0 ? 0 : Math.abs(this.accountActivityNodeBank);
  // }

  getTranslatedErrorText(): string {
    return `Can not be less than ${this.PROPaymentSetting.CurrentNPMBank} NPM`;
  }

  getPredictedNPMUsageData() {
    const today = new Date();

    let baseDateForCycle = new Date(today);
    if (today.getDate() < this.PROPaymentSetting.DocDay) {
      baseDateForCycle.setMonth(baseDateForCycle.getMonth() - 1);
    }
    
    const startYear = baseDateForCycle.getFullYear();
    const startMonth = baseDateForCycle.getMonth();
    
    const daysInStartMonth = new Date(startYear, startMonth + 1, 0).getDate();
    const startDay = Math.min(this.PROPaymentSetting.DocDay, daysInStartMonth);
    const startDate = new Date(startYear, startMonth, startDay);

    let nextCycleYear = startYear;
    let nextCycleMonth = startMonth + 1;

    if (nextCycleMonth > 11) {
      nextCycleMonth = 0;
      nextCycleYear += 1;
    }

    const daysInNextCycleMonth = new Date(nextCycleYear, nextCycleMonth + 1, 0).getDate();
    const nextCycleStartDay = Math.min(this.PROPaymentSetting.DocDay, daysInNextCycleMonth);
    const nextCycleStartDate = new Date(nextCycleYear, nextCycleMonth, nextCycleStartDay);
    
    const endDate = new Date(nextCycleStartDate);
    endDate.setDate(endDate.getDate() - 1);
    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(23, 59, 59, 999);

    const formatDate = (date) => `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
    // console.log(`DocDay: ${this.PROPaymentSetting.DocDay}, 今天: ${formatDate(today)}`);
    // console.log(`Range: ${formatDate(startDate)} - ${formatDate(endDate)}`);

    this.predictedNPMUsage.SettlementDate = `${formatDate(nextCycleStartDate)}`
  }

  saveCustomer() {
    if (this.dialogVisibility.addCustomer) {
      const params = {
        Region: this.addCustomerDialogInput.name,
        RegionName: this.addCustomerDialogInput.name,
        RegionId: this.parentRegionId,
        IsMsp: true,
        PlanMgtId: this.default100NPlanMgtId,
        IsDistributor: false,
        UnitPrice: 2.25,
        OwnerAccount: this.addCustomerDialogInput.ownerAccount,
        PaymentRegionId: this.addCustomerDialogInput.type.toString() === '0' ? this.regionId : 0,
        Nodes: this.addCustomerDialogInput.type.toString() === '1' ? this.addCustomerDialogInput.quantity : null
      };
      this.store.dispatch(new fromMyfeatures.AddRegions(params));
    }
    if (this.dialogVisibility.editCustomer) {
      const params = {
        id: this.selectedCustomer.Id,
        changes: {
          Region: this.addCustomerDialogInput.status === PROStatusIndex.Waiting ? this.addCustomerDialogInput.name : null,
          RegionName: this.addCustomerDialogInput.status === PROStatusIndex.Waiting ? this.addCustomerDialogInput.name : null,
          PaymentRegionId: this.addCustomerDialogInput.type.toString() === '0' ? this.regionId : this.selectedCustomer.Id,
          OwnerAccount: this.addCustomerDialogInput.status === PROStatusIndex.Waiting ? this.addCustomerDialogInput.ownerAccount : null,
        }
      };
      this.store.dispatch(new fromMyfeatures.UpdateRegions(params));
    }
  }
  
  sendInvitation(rowData) {
    this.ngxService.start();
    const param = { RegionId: rowData.Id };
    this.store.dispatch(new fromMyfeatures.SendProUpgradeMail(param));
  }
  
  addPaymentAgreement() {
    this.ngxService.start();
    const param = {
      Region: this.regionId,
      returnUrl: urlPath.ProManagementCompany
    };
    this.store.dispatch(new fromFeature.GetPayPalAgreementApprovalUrlAction(param));
  }
  
  // 渲染 PayPal 按鈕的私有方法
  private renderPayPalButton(): void {
    const pthis = this;

    // 如果容器還不存在，就不要執行
    if (!this.paypalContainerRef) {
      return;
    }
    // 先清空，以防萬一重複渲染
    this.paypalContainerRef.nativeElement.innerHTML = '';

    paypal.Buttons({
      style: this.paypalBtnStyle,
      onInit: (data, actions) => {
        pthis.paypalActions = actions;
        if (!pthis.isFormValid) {
          actions.disable();
        }
      },
      // onClick：在使用者點擊按鈕時，可以做最後一次的同步驗證
      onClick: (data, actions) => {
        if (!pthis.isFormValid) {
          return actions.reject(); // 阻止付款流程
        }
        return actions.resolve(); // 驗證通過，允許繼續
      },
      createOrder: function(data, actions) {
        pthis.ngxService.start();
        const selectedItemDescription = `${pthis.CurrentUser} , PRO, ${pthis.PayByCardDialogInput.quantity} NPM`;
        const UnitPrice = pthis.paymentUnitPrice;
        const tax = 0;
        const quantity = pthis.PayByCardDialogInput.quantity;
        let priceTotal = quantity * UnitPrice + tax;
        priceTotal = Math.round(priceTotal * 100) / 100;
        const itemTotalValue = Math.round((UnitPrice * quantity) * 100) / 100;

        return actions.order.create({
          purchase_units: [{
            description: selectedItemDescription,
            amount: {
              currency_code: 'USD',
              value: priceTotal,
              breakdown: {
                item_total: {
                  currency_code: 'USD',
                  value: itemTotalValue,
                },
                shipping: {
                  currency_code: 'USD',
                  value: 0,
                },
                tax_total: {
                  currency_code: 'USD',
                  value: tax,
                }
              }
            },
            items: [{
              name: selectedItemDescription,
              unit_amount: {
                currency_code: 'USD',
                value: UnitPrice,
              },
              quantity: quantity
            }]
          }]
        });
      },
      onApprove: function(data, actions) {
        return actions.order.capture().then(function(details) {
          const CaptureId = details.purchase_units[0].payments.captures[0].id; // PayPal transcation id.
          // const CurrencyCode = details.purchase_units[0].amount.currency_code;
          const purchaseUnit = details.purchase_units[0];
          const captureDetails = purchaseUnit.payments.captures[0];
          const finalAmount = captureDetails.amount.value; // 最終結算金額 (字串格式，例如 "200.00")
          const OrderId = details.id;
          const params = {
            RegionId: pthis.regionId,
            CurrencyCode: 'USD', // For now, only USD.
            Nodes: Number(pthis.PayByCardDialogInput.quantity),
            Amount: parseFloat(finalAmount),
            OrderId: OrderId,
            CaptureId: CaptureId
          };
          pthis.store.dispatch(new fromFeature.AddProPaymentPay(params));
        });
      },
      onError: function(err) {
        pthis.ngxService.stop();
        const res: UpdateInfoModel = {
          result: false,
          errmsg: err,
          type: updateInfoType.CreateOrder
        };
        pthis.store.dispatch(new fromFeature.UpdateInfoFailAction(res));
        pthis.PayByCardResult = 1;
        pthis.dialogVisibility.PayByCard = false;
        pthis.dialogVisibility.PayByCardResult = true;
      },
      onCancel: function(data) {
        pthis.ngxService.stop();
      }
    }).render(pthis.paypalContainerRef.nativeElement);
    // console.log('PayPal button rendered successfully.', this.paypalContainerRef.nativeElement);
  }

  errorCompanyMember(e) {
    const type = parseInt(e.RespType)
    if (type !== 0) {
      this.transferAccountError = true;
      if (type == 1) {
        this.transferAccountErrorMessage = 'No Account Found';
      } else if (type == 2 || type == 3) {
        this.transferAccountErrorMessage = 'This account has been upgraded to PPC PRO';
      }
    } else {
      this.transferAccountError = false;
      this.addCustomerStep(2);
    }
  }

  hasQuantityError(): boolean {
    return this.addCustomerDialogInput.quantity < 0 ||
           this.accountActivityNodeBank < 0 ||
           this.addCustomerDialogInput.quantity > this.accountActivityNodeBank ||
           (this.addCustomerDialogInput.quantity > (this.accountActivityNodeBank - this.unActiveCompanyNPM));
  }

  GetPaymentSettingByRegionId(PaymentSettingArray, regionId) {
    for (const paymentSetting of PaymentSettingArray) {
      if (paymentSetting.MspRegionId === regionId) {
        if (Array.isArray(paymentSetting.Customers) && paymentSetting.Customers.length > 0) {
          for (const customer of paymentSetting.Customers) {
            this.region_docDay_dic[customer.MspRegionId] = customer.DocDay;
          }
        }
        this.region_docDay_dic[paymentSetting.MspRegionId] = paymentSetting.DocDay;
        return paymentSetting;
      }
      if (Array.isArray(paymentSetting.Customers) && paymentSetting.Customers.length > 0) {
        const foundCustomer = paymentSetting.Customers.find(customer => customer.MspRegionId === regionId);
        if (foundCustomer) {
          this.region_docDay_dic[foundCustomer.MspRegionId] = foundCustomer.DocDay;
          return foundCustomer;
        }
      }
    }
    return null;
  }
}
